module.exports = __webpack_public_path__ + "img/bridge_short.ba6ec985.png";